require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconUser.tsx
var IconUser_exports = {};
__export(IconUser_exports, {
  default: () => IconUser_default
});
module.exports = __toCommonJS(IconUser_exports);

// src/assets/monochrome/user.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgUser = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.502 5.27137C12.502 6.62024 11.3819 7.71371 10.0001 7.71371C8.61839 7.71371 7.49827 6.62024 7.49827 5.27137C7.49827 3.92251 8.61839 2.82904 10.0001 2.82904C11.3819 2.82904 12.502 3.92251 12.502 5.27137ZM14.3756 5.27137C14.3756 7.63039 12.4166 9.54275 10.0001 9.54275C7.58362 9.54275 5.62466 7.63039 5.62466 5.27137C5.62466 2.91236 7.58362 1 10.0001 1C12.4166 1 14.3756 2.91236 14.3756 5.27137ZM4.37361 18.0853C4.37361 15.0518 6.89263 12.5927 10 12.5927C13.1074 12.5927 15.6264 15.0518 15.6264 18.0853C15.6264 18.5903 16.0458 18.9998 16.5632 18.9998C17.0806 18.9998 17.5 18.5903 17.5 18.0853C17.5 14.0417 14.1421 10.7637 10 10.7637C5.85786 10.7637 2.5 14.0417 2.5 18.0853C2.5 18.5903 2.91942 18.9998 3.4368 18.9998C3.95419 18.9998 4.37361 18.5903 4.37361 18.0853Z", fill: "#818898" }) });
var user_default = SvgUser;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconUser.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconUser = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(user_default, {}) });
};
IconUser.displayName = "IconUser";
var IconUser_default = IconUser;
